<template>
  <div class="agila-info-block" :class="{ small: props.small }">
    <div class="info-block-wrapper">
      <div class="agila-icon-info-circle" v-if="props.showIcon"></div>
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, withDefaults } from "vue";

interface Props {
  showIcon?: boolean;
  small?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showIcon: true,
  small: false,
});
</script>

<style scoped lang="scss">
.agila-info-block {
  display: block;
  border-left: 4px solid var(--color-blue-standard);
  padding: 4px 11px;
  color: var(--color-gray-700);
  background-color: var(--color-white);
  line-height: 24px;
  font-family: var(--font-open-sans-regular), sans-serif;
  margin-bottom: 20px;

  &.small {
    font-size: 13px;
    line-height: normal;
  }

  .info-block-wrapper {
    display: inline-flex;
    align-items: center;
  }

  .agila-icon-info-circle {
    margin-right: 12px;
  }
}
</style>
